<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
<template>
    <div id="loader"
         class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
         :class="{hidden: loaderHidden}">
        <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
            <img class="inline-block" src="/storage/img/loader.gif"/>
        </div>
    </div>
    <form @submit.prevent="form.post('/orders', options)">
        <div class="pb-6 pt-2 bg-slate-100 border-b border-gray-200 shadow-sm rounded-lg">
            <div class="flex relative mt-5 flex-wrap justify-around">
                <div class="w-full sm:w-8/12 px-2 sm:px-5 lg:px-10 mb-2">
                    <div class="flex flex-wrap">
                        <div class="w-1/2">
                            <label for="email">Email</label>
                            <!--:required="emailRequired"-->
                            <input
                                   oninvalid="this.setCustomValidity('Inserir email ou telefone')"
                                   oninput="this.setCustomValidity('')" @change="changeEmail($event)" autocomplete="off"
                                   v-model="form.email"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                   id="email" type="email"/>
                            <p v-if="form.errors.email" class="text-red-500 text-xs italic">É obrigatório pelo menos um
                                dos
                                campos: email ou telefone</p>
                        </div>
                        <div class="w-1/2 pl-2">
                            <label for="phone">Telefone</label>
                            <!--:required="phoneRequired"-->
                            <input
                                   oninvalid="this.setCustomValidity('Inserir email ou telefone')"
                                   oninput="this.setCustomValidity('')" @change="changePhone($event)" autocomplete="off"
                                   v-model="form.phone"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                   id="phone" type="tel"/>
                            <p v-if="form.errors.phone" class="text-red-500 text-xs italic">É obrigatório pelo menos um
                                dos
                                campos: email ou telefone</p>
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="w-full sm:w-6/12">
                            <label for="name">Nome</label>
                            <input required autocomplete="off" v-model="form.name" ref="formName"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                   id="name" type="text"/>
                            <p v-if="form.errors.name" class="text-red-500 text-xs italic">Este campo é obrigatório</p>
                        </div>
                        <div class="w-full sm:w-6/12 xl:w-2/12 sm:pl-2">
                            <label for="discounts">Levantamento</label>
                            <select v-model="form.pickup_type"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="pickup_type">
                                <option value="1">Transportadora</option>
                                <option value="2">Em Loja</option>
                            </select>
                            <p v-if="form.errors.pickup_type" class="text-red-500 text-xs italic">Este campo é
                                obrigatório</p>
                        </div>
                        <div class="w-full sm:w-6/12 xl:w-2/12 xl:pl-2">
                            <label for="discounts">Desconto (€)</label>
                            <input required autocomplete="off" v-model="form.discounts"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                   id="discounts" type="number" step=".01"/>
                            <p v-if="form.errors.discounts" class="text-red-500 text-xs italic">Este campo é
                                obrigatório</p>
                        </div>
                        <div class="w-full sm:w-6/12 xl:w-2/12 sm:pl-2">
                            <label for="shipping_value">Custos de envio (€)</label>
                            <input required autocomplete="off" v-model="form.shipping_value"
                                   class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                   id="shipping_value" type="number" step=".01"/>
                            <p v-if="form.errors.shipping_value" class="text-red-500 text-xs italic">Este campo é
                                obrigatório</p>
                        </div>
                    </div>
                </div>
                <div class="w-full sm:w-4/12 px-2 sm:px-5 lg:px-10 mb-2">
                    <label for="observations">Observações</label>
                    <textarea name="observations" v-model="form.observations" id="observations" rows="4"
                              class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"></textarea>
                </div>
                <transition name="fade">
                    <div v-if="form.address !== ''" class="w-full sm:w-4/12 px-5 mb-2">
                        <label for="address">Morada</label>
                        <textarea name="address" v-model="form.address" id="address" rows="4"
                                  class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"></textarea>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="form.country !== ''" class="w-full sm:w-4/12 px-5 mb-2">
                        <label for="country">País</label>
                        <input type="text" name="country" v-model="form.country" id="country"
                               class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"/>
                    </div>
                </transition>

            </div>
        </div>
        <div class="py-5 pl-1 sm:pl-4 lg:pl-9 pr-7 bg-slate-100 mt-5 border-b border-gray-200 shadow-sm rounded-lg">
            <form-lines @update-form-lines="updateFormLines" :key="formKey" :form="form"
                        :article_codes="article_codes" :checked_in="{self: true}"/>
            <div class="text-right mt-5">
                <button :disabled="form.processing"
                        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow"
                        type="submit">
                    <i class="fa fa-plus-square"></i> Submeter Encomenda
                </button>
            </div>
        </div>
    </form>
</template>

<script>

import {useForm} from '@inertiajs/inertia-vue3'
import Swal from 'sweetalert2'
import FormLines from "@/Components/Order/FormLines";
import FormLinesActions from "@/Components/Order/FormLinesActions";
import {ref, watch} from "vue";


export default {
    components: {FormLinesActions, FormLines},
    props: ['site_url', 'article_codes'],
    setup(props) {
        const formKey = ref(0);
        const form = useForm({
            article_codes: props.article_codes,
            name: '',
            buyer_name: '',
            email: '',
            phone: '',
            address: '',
            country: '',
            observations: '',
            pickup_type: 1,
            discounts: 0,
            shipping_value: 0,
            order_line: [{
                article: {
                    id: '',
                    code: ''
                },
                qtd: '',
                tamanho: '',
                cor: '',
                reserved: false,
            }]
        });

        const options = {
            onBefore: function (formData) {
                loaderHidden.value = false;
            },
            onSuccess: function (result) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    html: 'Encomenda criada com sucesso com o nr ' + result.props.order_id + ' ! <br/><br/> <a class="text-sky-900 font-bold" target="_blank" href="' + props.site_url + '/orders/' + result.props.token + '">' + props.site_url + '/orders/' + result.props.token + '</a>'
                }).then(function () {
                    navigator.clipboard.writeText(props.site_url + '/orders/' + result.props.token).then(function () {
                        console.log('Copying to clipboard was successful!');
                    });
                    loaderHidden.value = true;
                });
                form.reset();
                formKey.value++;
            },
            onError: function () {
                Swal.fire('Erro, por favor tente mais tarde!', '', 'error');
            }
        }

        function updateFormLines(lines) {
            form.order_line = lines;
        }


        // let phoneRequired = ref(true);
        // let emailRequired = ref(true);

        function swalOpenOrders(openOrders) {
            if(Object.keys(openOrders).length > 0) {
                openOrders[Object.keys(openOrders)[0]] = openOrders[Object.keys(openOrders)[0]].filter(e => e.status_id < 5);
                if (openOrders[Object.keys(openOrders)[0]].length > 0) {
                    const data = openOrders[Object.keys(openOrders)][0];

                    let html = 'Existem encomendas em aberto feitas pelo(a) ' + data.name + '<br/><table class="shadow-none mx-auto w-3/4 mt-5">' +
                        '<thead class="shadow-none bg-gray-50">' +
                        '<tr>' +
                        '<th>Nr</th>' +
                        '<th class="text-left px-6">Estado</th>' +
                        '</tr>' +
                        '</thead>' +
                        '<tbody>';

                    openOrders[Object.keys(openOrders)].forEach(el => html += '\
            <tr>\
                <td style="padding-left: 1.5rem !important;padding-right:1.5rem !important;" class="text-sm text-blue-500"><a href="/orders/list/1%2C2%2C3%2C4%2C5?search=' + el.id + '" target="_blank">' + el.id + '</a></td>\
                <td style="padding-left: 1.5rem !important;padding-right:1.5rem !important;" class="text-sm text-gray-500 text-left">' + el.status.name + '</td>\
            </tr>\
            ');

                    html += '</tbody></table>';

                    Swal.fire({
                        title: '<strong class="lobster">Encomendas em aberto</strong>',
                        icon: 'warning',
                        html: html,
                        showCloseButton: true,
                        focusConfirm: false,
                        confirmButtonText:
                            'OK',
                        confirmButtonAriaLabel: 'OK'
                    });
                }
            }
        }

        function fillFields(result, event) {
            const field = event.target.value.toLowerCase();
            if (typeof result.data[field] !== undefined && result.data[field] && result.data[field].length > 0) {
                const found = result.data[field][0];

                form.name = found.name;
                form.buyer_name = found.buyer_name;
                form.phone = found.phone;
                if (typeof found.phone !== undefined && found.phone && found.phone.length > 0) {
                    formName.value.focus()
                }
                form.email = found.email;
                form.address = found.address;
                form.country = found.country;
            } else {
                form.address = '';
                form.country = '';
            }
        }

        function changeEmail(event) {
            if (event.target.value !== '' && form.phone === '') {
                // phoneRequired.value = false;
                // emailRequired.value = false;

                loaderHidden.value = false;
                axios.post('/orders/getEmailPhoneData', {
                    field: 'email',
                    value: event.target.value
                }).then(result => {
                    fillFields(result, event);
                    swalOpenOrders(result.data);
                    loaderHidden.value = true;
                });
            } else {
                if (form.phone === '' || form.phone === null) {
                    // phoneRequired.value = true;
                    // emailRequired.value = true;
                    form.address = '';
                    form.country = '';

                }
            }
        }

        const formName = ref('');

        function changePhone(event) {
            if (event.target.value !== '' && form.email === '') {
                // phoneRequired.value = false;
                // emailRequired.value = false;

                loaderHidden.value = false;
                axios.post('/orders/getEmailPhoneData', {
                    field: 'phone',
                    value: event.target.value
                }).then(result => {
                    fillFields(result, event);
                    swalOpenOrders(result.data);
                    loaderHidden.value = true;
                });
            } else {
                if (form.email === '' || form.email === null) {
                    // phoneRequired.value = true;
                    // emailRequired.value = true;
                    form.address = '';
                    form.country = '';
                    form.address = '';
                    form.country = '';
                }
            }
        }

        const loaderHidden = ref(true);
        return {
            form,
            formName,
            options,
            updateFormLines,
            // emailRequired,
            // phoneRequired,
            changePhone,
            changeEmail,
            formKey,
            loaderHidden
        }
    }
}
</script>
